import React, { useState, useEffect, useMemo, useContext } from "react";
import AnnouncementPost from "./AnnouncementPost";
import Search from "../../../CommonComponents/Search";
import Loading from "../../../Notification-Loading/Loading/Loading";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import useS3FileManagement from "../../../../Hooks/useS3FileManagement";
import constants from "../../../../constants";
import { nanoid } from "nanoid";
import { useDebouncedValue } from "../../../../Hooks/useDebounceValue";
import AlertContext from "../../../../context/AlertContext";


const StudentNoticeBoard = () => {
  const axios = useAxiosPrivate();
  const { getCatchBlockDetails } = useCommonFunctionHooks();
  const { getPreSignedUrl } = useS3FileManagement();
  const Alert = useContext(AlertContext);
  const [searchValue, setSearchValue] = useState("");
  const [posts, setPosts] = useState([]);
  const [postLoading, setPostLoading] = useState(false);

  const debounceSearchValue = useDebouncedValue(searchValue, 500);

  const filteredNotices = useMemo(
    () =>
      posts.filter(
        (n) =>
          n.title.toLowerCase().includes(debounceSearchValue.toLowerCase()) ||
          n.description.toLowerCase().includes(debounceSearchValue.toLowerCase()),
      ),
    [debounceSearchValue, posts],
  );

  useEffect(() => {
    fetchAnnouncementDetails();
  }, []);

  const fetchAnnouncementDetails = async () => {
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp"];
    try {
      setPostLoading(true);
      Alert.setIsLoaded(true);
      const response = await axios.get(
        `/node/announcement?batchid=0&isLearner=true&companyId=${localStorage.getItem("companyId")}`,
      );
      if (response.data.resultCode !== constants.RESULT_STATUS.SUCCESS) {
        throw new Error("Something Went Wrong");
      }
      let allPost = response.data.data;
      for (let post of allPost) {
        let preSignedUrl = [];
        let attachment =
          typeof post.attachments === "object"
            ? post.attachments
            : JSON.parse(post.attachments);
        const images = attachment.filter((file) =>
          imageExtensions.includes(file.url.split(".").pop()?.toLowerCase()),
        );

        const files = attachment.filter(
          (file) =>
            !imageExtensions.includes(file.url.split(".").pop()?.toLowerCase()),
        );

        for (let image of images) {
          // console.log("image:", image);
          let fileTypeArr = [];
          let fileNameArr = [];
          let key = image.url;
          fileTypeArr.push(image.url.split(".").pop());
          fileNameArr.push(image.url.split(".")[0].split("/").pop());
          let pre = await getPreSignedUrl(key, undefined, fileTypeArr, "GET");
          preSignedUrl.push({
            url: pre.url,
            isdownloadable: image.isdownloadable,
            id: nanoid(),
            key:key,
          });
        }

        for (let a of attachment) {
          a.id = nanoid();
        }
        post.attachments = files;
        post.images = images;
        post.preSignedUrl = preSignedUrl;
      }
      setPosts(response.data.data);
    } catch (error) {
      console.log("error:",error); 
      getCatchBlockDetails(error);
    } finally {
      setPostLoading(false);
      Alert.setIsLoaded(false);
    }
  };

  return (
    <div className="page-container">
      <main className="main-content">
        {/* Header */}
        <div className="top-header">
          <div className="header-top">
            <div className="header-title">
              <h2>Notice Updates</h2>
              <p>Stay updated with the new announcements</p>
            </div>
            <Search
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
        </div>

        {/* Notice feed */}
        {/* {postLoading && <Loading overlay/>} */}

        <div style={{ height: "calc(100vh - 100px)", overflowY: "scroll" }}>
          <div className="notice-feed">
            {filteredNotices.length ? (
              filteredNotices.map((notice) => (
                <div key={notice.id} className="notice-card">
                  <div className="notice-inner">
                    <AnnouncementPost
                      isAdmin={false}
                      authorName={notice.author}
                      postedTo={notice.batch}
                      timestamp={notice.time}
                      badgeLabel={notice.badge}
                      title={notice.title}
                      description={notice.description}
                      attachments={
                        typeof notice.attachments === "object"
                          ? notice.attachments
                          : JSON.parse(notice.attachments) ?? []
                      }
                      images={
                        typeof notice.preSignedUrl === "object"
                          ? notice.preSignedUrl
                          : JSON.parse(notice.preSignedUrl) ?? []
                      }
                      initialLikes={notice.likes}
                      post={notice}
                      initialComments={
                        typeof notice.comments === "object"
                          ? notice.comments
                          : JSON.parse(notice.comments) ?? []
                      }
                    />
                  </div>
                </div>
              ))
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "40px 20px",
                  color: "#6b7280",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                No results found.
              </div>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default StudentNoticeBoard;
